import "./RecentBooksScreen.css";

const IncompleteBooksScreen = ({ allBooks = [], users = [], currentUser, onBack, onBookClick }) => {
  const uid = currentUser?.uid;

  // Only include books that at least one user has registered
  const ownedBookIds = new Set((users || []).flatMap(u => u.bookIds || []));

  const incompleteBooks = allBooks
    .filter(b => {
      if (!ownedBookIds.has(b.id)) return false;
      const completedBy = b.completedBy || {};
      return Object.keys(completedBy).length === 0;
    })
    .sort((a, b) => (b.registeredDate || "").localeCompare(a.registeredDate || ""));

  const getOwners = (book) => {
    return (users || [])
      .filter(u => u.id !== uid && (u.bookIds || []).includes(book.id))
      .map(u => u.name)
      .slice(0, 3);
  };

  return (
    <div className="bp-layer bp-layer-full">
      <div className="back-bar" onClick={onBack}>← <span>돌아가기</span></div>

      <div className="recent-header">
        <div className="recent-title">📖 미완독 책</div>
        <div className="recent-sub">아직 아무도 완독하지 않은 {incompleteBooks.length}권의 책</div>
      </div>

      <div className="recent-list">
        {incompleteBooks.length === 0 ? (
          <div className="recent-empty">미완독 책이 없어요</div>
        ) : (
          incompleteBooks.map((b, i) => {
            const owners = getOwners(b);
            return (
              <div
                key={b.id}
                className="recent-item"
                style={{ animationDelay: `${i * 0.06}s` }}
                onClick={() => onBookClick(b.id)}
              >
                <div className="recent-cover" style={{ background: b.bg || "#1a1a2e" }}>
                  {b.cover
                    ? <img src={b.cover} alt={b.title} />
                    : <span>{b.emoji || "📖"}</span>
                  }
                </div>
                <div className="recent-info">
                  <div className="recent-book-title">{b.title}</div>
                  <div className="recent-book-author">{b.author}</div>
                  <div className="recent-book-meta">
                    {b.registeredDate && <span className="recent-date">📅 {b.registeredDate}</span>}
                    <span className="recent-genre">{b.genre}</span>
                  </div>
                  {owners.length > 0 && (
                    <div className="recent-owners">
                      📡 {owners.join(", ")}님이 읽는 중
                    </div>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default IncompleteBooksScreen;
